import { ROUTE_ENUM, SVG_ENUM } from "enums";
import React from "react";
import { SVG } from "shared";
import { useNavigate } from "react-router";
import { isDesktop } from "utils";

interface RegulationsProps {
  handleGoBack: () => void;
}

const REGULATIONS_LINKS = [
  { label: "Regulamin Aplikacji Reliance", route: ROUTE_ENUM.TERMS_OF_SERVICE },
  { label: "Polityka prywatności", route: ROUTE_ENUM.PRIVACY_POLICY },
  { label: "Klauzula RODO", route: ROUTE_ENUM.RODO },
  {
    label: "Regulamin sukcesji",
    route: ROUTE_ENUM.TERMS_OF_SERVICE_SUCCESSION,
  },
];

const Regulations: React.FC<RegulationsProps> = ({ handleGoBack }) => {
  const navigate = useNavigate();
  const handleRegulationClick = (route: ROUTE_ENUM) => {
    if (isDesktop()) {
      window.open(route, "_blank", "noopener,noreferrer");
    } else {
      navigate(route);
    }
  };

  return (
    <div className="profile__right-wrapper">
      <div className="profile__right-back" onClick={() => handleGoBack()}>
        <span className="profile__right-back-icon">
          <SVG type={SVG_ENUM.ARROW_BACK} />
        </span>
        Wróć
      </div>
      <h2 className="profile__menu-header">
        <span className="profile__menu-icon profile__menu-icon--right">
          <SVG type={SVG_ENUM.REGULATIONS} />
        </span>
        Regulaminy
      </h2>
      <div className="profile__regulations-list">
        {REGULATIONS_LINKS.map(({ label, route }) => (
          <div
            key={route}
            className="profile__regulations-row"
            onClick={() => handleRegulationClick(route)}
          >
            {label}
            <SVG type={SVG_ENUM.CHEVRON_RIGHT} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Regulations;
